
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCoupon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22.222 18.5v-3.316c0-.276-.227-.495-.5-.536-2.555-.386-2.555-3.726 0-4.112.273-.041.5-.26.5-.536V6.5a.5.5 0 0 0-.5-.5H2.5a.5.5 0 0 0-.5.5V10c0 .276.227.496.501.53 2.807.36 2.675 3.744 0 4.12-.274.038-.501.258-.501.534V18.5a.5.5 0 0 0 .5.5h19.222a.5.5 0 0 0 .5-.5Z",
  stroke: "#4A4A4A",
  strokeWidth: 1.6
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.8 6.8v11.4",
  stroke: "#4A4A4A",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeDasharray: "3 3"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\">\r\n  <path d=\"M22.2222 18.5V15.1838C22.2222 14.9077 21.9954 14.6888 21.7224 14.6476C19.1666 14.2623 19.1666 10.9215 21.7224 10.5362C21.9954 10.495 22.2222 10.2761 22.2222 10V6.5C22.2222 6.22386 21.9984 6 21.7222 6H2.5C2.22386 6 2 6.22386 2 6.5V10C2 10.2761 2.22714 10.4958 2.50105 10.5308C5.308 10.8898 5.17611 14.2739 2.50024 14.6499C2.22678 14.6883 2 14.9077 2 15.1838V18.5C2 18.7761 2.22386 19 2.5 19H21.7222C21.9984 19 22.2222 18.7761 22.2222 18.5Z\" stroke=\"#4A4A4A\" stroke-width=\"1.6\"/>\r\n  <path d=\"M8.79999 6.7998V18.1998\" stroke=\"#4A4A4A\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-dasharray=\"3 3\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/coupon.a4a8cb8e02e9bbc711b655f64a9b6f02.svg"),
        {
          React: SvgCoupon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      